import { createModelRegistry } from './modelRegistry.js'
export const MODEL_CONFIG = {
  deepseek: {
    label: 'DeepSeek 深度求索',
    shortLabel: 'DeepSeek',
    models: ['deepseek-flash', 'deepseek-v4-pro'],
    defaultModel: 'deepseek-flash',
  },
  gemini: {
    label: 'Google Gemini',
    shortLabel: 'Gemini',
    models: ['gemini-3.6-flash', 'gemini-3.1-flash-lite', 'gemini-3.1-pro-preview'],
    defaultModel: 'gemini-3.6-flash',
  },
}

export const normalizeProvider = (provider) => (MODEL_CONFIG[provider] ? provider : 'deepseek')
export const getDefaultModel = (provider) => MODEL_CONFIG[normalizeProvider(provider)].defaultModel

export const AI_SETTING_KEYS = {
  legacy: 'hx_ai_settings_v2',
  provider: 'insurancePortal.provider',
  model: 'insurancePortal.model',
  deepseekKey: 'insurancePortal.deepseekApiKey',
  geminiKey: 'insurancePortal.geminiApiKey',
}

export const modelRegistry = createModelRegistry(MODEL_CONFIG)
export const normalizeModel = (provider, model) => modelRegistry.resolve(normalizeProvider(provider), model)
